import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

new Vue({
    created: function() {},
    beforeMount: function() {},
    mounted: function() {},
    render: h => h(App),
    beforeCreate: function() {},
}).$mount('#fredsApp');
